<template>
    <div class="addressSelect-box wk-input-box" :style="styleCpt">
        <span class="input-left-label" v-if="label">{{label}}</span>
        <span v-else style="padding-left:1.9rem;" :style="labelStyle">{{label}}</span>
        <div class="posi-relative">
            <input-base :id="id" classCpt="addressSlt-input cur-pot" v-model="inputVal" 
                :placeholder="placeholderOver" ref="inputRef" :initVal='value' readonly />
            <div class="ssx-box posi-absolute bg-white hide">
                <div class="ssx-title flex-jf-btw">
                    <p class="ssxItem" :class="{active:addressSlt==1}" @click="addressTitleClick(1)">省</p> 
                    <p class="ssxItem" :class="{active:addressSlt==2}" @click="addressTitleClick(2)">市</p> 
                    <p class="ssxItem" :class="{active:addressSlt==3}" @click="addressTitleClick(3)">县</p>
                </div>
                <!--具体省市县的展示-->
                <ul class="ssx-list posi-absolute ssxItem">
                    <li v-for="(item,index) in addressItemList" :key="index"
                        @click="addressItemClick(item,true)" class="ssxItem"
                        :class="{active:addressSltName==item.name}">{{item.name}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','id', 'type','placeholder','value','labelStyle','styleCpt'],
        mounted(){
            // 请求地址数据
            this.$axios_post("/other/provinceCityByDB").then(res=>{
              console.log(res,'请求的地址信息')
              if(res.code == '00000000'){
                this.addressList = res.dataList
              }
            })
            this.initAddressSlt(this);        
            this.placeholderOver =  this.label || this.placeholder;
        },
        watch:{
            inputVal(){
                this.$emit('input',this.inputVal)
            }
        },
        data(){
            return{
                inputVal:'',
                addressSlt:'1',//当前选中的省市县title索引
                addressSltName:'',//当前展示的列表中选中的内容
                addressList:[], //当前省市县列表
                addressItemList:[], //当前省市县列表
                province:'', //居住地址--省	
                city:'', //居住地址--市
                county:'', //居住地址--县	
                address:'', //居住地址
                placeholderOver:''
            }
        },
        methods:{
            //初始化地址选择
            initAddressSlt(that){
                let tmpId = '#'+ that.id;  
                //获得所有省市县
                // that.addressList = that.$tools.getShengShiXian();
                console.log(that.addressList,'that.addressListthat.addressListthat.addressListthat.addressListthat.addressList')
                //省市县的选择
                $(tmpId).click((e)=>{  
                    that.addressSlt = 1; 
                    //默认显示 省
                    that.provinceInit();
                    //获得所有省市县
                    // that.addressList = that.$tools.getShengShiXian();
                    //当前点击的
                    let tmpCurren = $(e.target).parent();
                    //如果当前是隐藏的,则显示
                    if(tmpCurren.next('.ssx-box').hasClass('hide')){                   
                        //如果选中的内容被清除 或是 还没选择
                        if(that.$refs.inputRef.getValue() == ''){
                            that.addressSltName = '';//当前展示的列表中选中的内容
                            that.province = ''; //居住地址--省	
                            that.city = ''; //居住地址--市
                            that.county = ''; //居住地址--县	
                            that.address = ''; //居住地址
                        }else{                            
                            that.addressSltName = that.address.split('/')[0];
                        }                        
                        tmpCurren.next('.ssx-box').css('display','block').removeClass('hide').addClass('show');
                    }else{//-- 隐藏
                        tmpCurren.next('.ssx-box').css('display','none').removeClass('show').addClass('hide');
                    }
                });
                //点击窗口的其他位置，隐藏省市县的选择
                $(window).click((e)=>{
                    //如果没有点击输入框 和 有关选择项
                    if(!$(e.target).hasClass('addressSlt-input') &&
                    !$(e.target).hasClass('ssxItem')){  
                        //隐藏 省市县的 弹出框
                        $('.ssx-box').css('display','none').removeClass('show').addClass('hide');
                    }
                })
            },
            //居住地址 省初始化
			provinceInit(){
          this.addressItemList = [];
              for(let t in this.addressList){
                this.addressItemList.push({deep:this.addressSlt,name:this.addressList[t].provinceName})
              }
            },
            //居住地址的 title的单击事件
			addressTitleClick(deep){
				if( this.addressSlt == deep){ return; }
			 	if(deep == 1){
					this.addressItemList = [];
					this.addressSlt = deep;
					for(let t in this.addressList){
						this.addressItemList.push({deep:1,name:this.addressList[t].provinceName})
					}
					this.addressSltName = this.address.split('/')[0];
			 	}
			 	//点击市 title，就相当于点击某个省
			 	if(deep == 2 && this.city != ''){
			 		let tCity = this.address.split('|')[0]; 
			 		this.addressSlt = deep;
			 		this.addressSltName = this.address.split('|')[1];
			 		this.addressItemClick({deep:1,name:tCity},false); 			 		
			 	}
			 	//点击县 title，就相当于点击某个市
			 	if(deep == 3 && this.county != ''){
			 		let tCounty = this.address.split('|')[1]; 
			 		this.addressSlt = deep;
			 		this.addressSltName = this.address.split('|')[2];
			 		this.addressItemClick({deep:2,name:tCounty},false); 			 		
			 	}
			},
			//居住地址的 选项的单击事件
			addressItemClick(item,isClear){
				if(item.deep == '1'){ //省
					this.addressSlt = 2; //选择了省直接选市
					this.addressItemList = [];
					this.province = item.name + "|";
					//如重新选择了某个省，则清除已选的市 和 县
					if(isClear){ this.city = this.county = ''; }
					//遍历所有的 省
					for(let t in this.addressList){
						let province = this.addressList[t];
						//匹配到当前的省，得到省下面的所有市
						if(province.provinceName == item.name){
							//遍历所有的 市
							for(let c in province.cityList){
								let city = province.cityList[c];
								this.addressItemList.push({deep:this.addressSlt,name:city.cityName})
							}
						}
					}
				}else if(item.deep == '2'){ //市
					this.addressSlt = 3; //选择了市直接选省	
					this.addressItemList = [];
					this.city = item.name + "|";
					//如重新选择了某个市，则清除已选的 县
					if(isClear){ this.county = ''; }
					//遍历所有的 省
					for(let t in this.addressList){
						let province = this.addressList[t];
						//遍历所有的 市
						for(let c in province.cityList){
							let city = province.cityList[c];
							if(city.cityName == item.name){
								let county = city.countyNameList;
								for(let xian in county){
									this.addressItemList.push({deep:this.addressSlt,name:county[xian]})
								}	
							}
						} 
					}
				}else{ //县
					this.county = item.name + "|"; 
					this.isAaddressList = false;
                    //选择了县 即最后一个选择项后，隐藏省市县的弹框
                    if(this.county != '' && this.city != ''){
                        $('.ssx-box').css('display','none').removeClass('show').addClass('hide');
                    }
				}
                this.address = this.province + this.city + this.county;
                //把值传到父组件的 v-model
                this.$emit('input',this.address);
                //把值显示到 input 里
                this.$refs.inputRef.setValue(this.address);
			}
        }
    }
</script>
<style lang="less" scoped>
    .addressSelect-box{
        margin:.9rem 0;
        >div.posi-relative{
            //-- 省市县选择的 容器
            .ssx-box{
                width:20.5rem; 
                height:15rem; 
                border:.05rem solid #D1D1D1; 
                top:2.05rem; 
                left:0; 
                z-index: 1;    
                display: none;          
                //--- 省市县的title
                .ssx-title{
                    p{
                        flex:1; 
                        padding:.55rem 0;
                        border-bottom: .05rem solid #D1D1D1;
                        background: #E7E7E7;
                        text-align: center; 
                        font-size: .7rem;
                        cursor: pointer;
                    }
                    p.active{
                        background: #fff;
                        color:#DB2513;
                    }
                }
                //-- 省市县的 list
                .ssx-list{
                    height:12.8rem;
                    width:20.5rem;
                    padding:.4rem .4rem 0;
                    overflow-y:auto; 
                    li{ 
                        padding:.4rem;
                        cursor: pointer;
                    }
                    li:hover,li.active{
                        color:#DB2513;
                    }
                }  
            }
        }
    }
</style>
<style lang="less">
    .addressSelect-box {
        input[readonly='readonly']{
            background:#fff;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/BaseCpts/addressSelect.vue